import type { Comic } from '../types/content';

export const comics: Comic[] = [
  {
    id: 'comic-001',
    title: '星海拾荒者',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20lone%20space%20scavenger%20girl%20in%20a%20worn%20orange%20spacesuit%20floating%20among%20glowing%20green%20nebula%20debris%2C%20vibrant%20cel%20shaded%20art%20style%2C%20clean%20simple%20background%2C%20high%20detail%2C%20portrait%20composition&width=600&height=800&seq=comic-cover-001&orientation=portrait',
    tags: ['科幻', '冒险', '太空'],
    genre: '科幻',
    status: '连载中',
    region: '国漫',
    author: '深蓝绘影',
    updatedAt: '2026-10-11',
    favorites: 28400,
    popularity: 96,
    rating: 9.4,
    summary: '在被废弃的星环带里，少女拾荒者靠捡拾飞船残骸为生。一次意外，她从坠毁战舰里救出一个自称“导航官”的机械少年，从此被卷入一场横跨星海的文明谜团。',
  },
  {
    id: 'comic-002',
    title: '雾都料理铺',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20cozy%20night%20food%20stall%20in%20a%20misty%20old%20town%20lit%20by%20warm%20lanterns%2C%20young%20chef%20in%20apron%20smiling%2C%20warm%20amber%20and%20green%20tones%2C%20vibrant%20cel%20shaded%20art%20style%2C%20simple%20clean%20background%2C%20portrait%20composition&width=600&height=800&seq=comic-cover-002&orientation=portrait',
    tags: ['日常', '美食', '治愈'],
    genre: '日常',
    status: '连载中',
    region: '日本',
    author: '小林暖',
    updatedAt: '2026-10-12',
    favorites: 41200,
    popularity: 93,
    rating: 9.2,
    summary: '雾气弥漫的老街深处，有一间只在午夜营业的料理铺。老板用一碗碗热汤，收留着每一个带着心事而来的客人。',
  },
  {
    id: 'comic-003',
    title: '第七班的地铁',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20teenage%20students%20boarding%20a%20glowing%20subway%20train%20late%20at%20night%2C%20mysterious%20green%20lighting%2C%20slice%20of%20life%20meets%20supernatural%2C%20vibrant%20cel%20shaded%20style%2C%20simple%20clean%20background%2C%20portrait%20composition&width=600&height=800&seq=comic-cover-003&orientation=portrait',
    tags: ['青春', '校园', '悬疑'],
    genre: '悬疑',
    status: '连载中',
    region: '韩国',
    author: '尹世真',
    updatedAt: '2026-10-10',
    favorites: 33900,
    popularity: 89,
    rating: 9.0,
    summary: '每天清晨七点零七分，那班地铁总会多出一节车厢——只有七个学生能看见。他们必须在天亮前解开当天的谜题，否则就会被留在里面。',
  },
  {
    id: 'comic-004',
    title: '刀锋记事簿',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20stoic%20young%20swordsman%20holding%20a%20katana%20under%20falling%20green%20leaves%2C%20dynamic%20action%20pose%2C%20vibrant%20cel%20shaded%20art%20style%2C%20simple%20clean%20background%2C%20portrait%20composition&width=600&height=800&seq=comic-cover-004&orientation=portrait',
    tags: ['热血', '古风', '战斗'],
    genre: '热血',
    status: '已完结',
    region: '国漫',
    author: '寒山客',
    updatedAt: '2026-09-28',
    favorites: 52100,
    popularity: 91,
    rating: 9.3,
    summary: '一个只会写字的书生，偏偏背起了刀。乱世之中，他用笔记录江湖，也用刀守护记录下来的每一个人。',
  },
  {
    id: 'comic-005',
    title: '魔法便利店',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20magical%20convenience%20store%20at%20dusk%20with%20glowing%20shelves%20filled%20with%20colorful%20potions%20and%20snacks%2C%20cheerful%20young%20clerk%20with%20a%20cat%2C%20vibrant%20green%20and%20amber%20palette%2C%20cel%20shaded%20style%2C%20portrait%20composition&width=600&height=800&seq=comic-cover-005&orientation=portrait',
    tags: ['奇幻', '搞笑', '轻松'],
    genre: '奇幻',
    status: '连载中',
    region: '日本',
    author: '森野青',
    updatedAt: '2026-10-13',
    favorites: 37600,
    popularity: 94,
    rating: 9.1,
    summary: '这家24小时便利店，买不买得到东西，全看你运气。魔药、龙鳞、会说话的饭团……当然，也可能只是打折的关东煮。',
  },
  {
    id: 'comic-006',
    title: '橙色的夏天',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20two%20high%20school%20students%20cycling%20along%20a%20seaside%20road%20at%20sunset%2C%20warm%20orange%20sky%2C%20sweet%20romance%20mood%2C%20vibrant%20cel%20shaded%20style%2C%20simple%20clean%20background%2C%20portrait%20composition&width=600&height=800&seq=comic-cover-006&orientation=portrait',
    tags: ['恋爱', '青春', '治愈'],
    genre: '恋爱',
    status: '连载中',
    region: '日本',
    author: '夏目遥',
    updatedAt: '2026-10-09',
    favorites: 44800,
    popularity: 92,
    rating: 9.2,
    summary: '转学来的第一个夏天，她认识了那个总把单车停在同一个位置、却从不说话的男生。有些喜欢，是一整个夏天都没说出口的橙色。',
  },
  {
    id: 'comic-007',
    title: '机械之心物语',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20gentle%20android%20girl%20with%20glowing%20green%20circuit%20lines%20on%20her%20face%20holding%20a%20small%20flower%2C%20soft%20sci-fi%20melancholy%20mood%2C%20vibrant%20cel%20shaded%20style%2C%20simple%20clean%20background%2C%20portrait%20composition&width=600&height=800&seq=comic-cover-007&orientation=portrait',
    tags: ['科幻', '治愈', '情感'],
    genre: '科幻',
    status: '连载中',
    region: '国漫',
    author: '零号工坊',
    updatedAt: '2026-10-08',
    favorites: 26500,
    popularity: 87,
    rating: 8.9,
    summary: '当一个人造人第一次学会“难过”，她能不能算是活着？在被雪覆盖的旧工厂里，一段关于心与记忆的温柔故事。',
  },
  {
    id: 'comic-008',
    title: '夜市降妖录',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20colorful%20traditional%20night%20market%20full%20of%20lanterns%20and%20food%20stalls%20with%20a%20young%20exorcist%20holding%20a%20talisman%2C%20supernatural%20fantasy%20mood%2C%20vibrant%20cel%20shaded%20style%2C%20portrait%20composition&width=600&height=800&seq=comic-cover-008&orientation=portrait',
    tags: ['玄幻', '民俗', '冒险'],
    genre: '玄幻',
    status: '连载中',
    region: '国漫',
    author: '陈九斤',
    updatedAt: '2026-10-12',
    favorites: 31200,
    popularity: 90,
    rating: 9.1,
    summary: '别人逛夜市是为了吃，他逛夜市是为了抓鬼。糖葫芦摊、戏台子、算命铺，每一处热闹背后都藏着几分不干净。',
  },
  {
    id: 'comic-009',
    title: '深海图书馆',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20vast%20underwater%20library%20with%20floating%20books%20and%20glowing%20jellyfish%2C%20a%20diver%20reading%20calmly%2C%20dreamy%20teal%20and%20green%20lighting%2C%20vibrant%20cel%20shaded%20style%2C%20portrait%20composition&width=600&height=800&seq=comic-cover-009&orientation=portrait',
    tags: ['奇幻', '冒险', '文艺'],
    genre: '奇幻',
    status: '连载中',
    region: '欧美',
    author: 'A. Marlowe',
    updatedAt: '2026-10-07',
    favorites: 22800,
    popularity: 85,
    rating: 8.8,
    summary: '海底三千米处，藏着一座会移动的图书馆。它收藏的不是书，而是被人彻底遗忘的故事。',
  },
  {
    id: 'comic-010',
    title: '爆改系统上线',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20confident%20young%20man%20surrounded%20by%20holographic%20green%20game%20interface%20panels%2C%20energetic%20gaming%20mood%2C%20vibrant%20cel%20shaded%20style%2C%20simple%20clean%20background%2C%20portrait%20composition&width=600&height=800&seq=comic-cover-010&orientation=portrait',
    tags: ['系统', '热血', '都市'],
    genre: '热血',
    status: '连载中',
    region: '国漫',
    author: '键盘侠本侠',
    updatedAt: '2026-10-13',
    favorites: 57900,
    popularity: 98,
    rating: 9.0,
    summary: '一觉醒来，外卖小哥发现自己绑定了“逆袭系统”。从送外卖开始，他要一步步把人生这场游戏打通关。',
  },
  {
    id: 'comic-011',
    title: '花间亭笔记',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20an%20elegant%20ancient%20pavilion%20surrounded%20by%20blooming%20flowers%20with%20a%20graceful%20lady%20in%20traditional%20dress%2C%20soft%20pastel%20tones%20with%20green%20accents%2C%20vibrant%20cel%20shaded%20style%2C%20portrait%20composition&width=600&height=800&seq=comic-cover-011&orientation=portrait',
    tags: ['古风', '爱情', '宫廷'],
    genre: '古风',
    status: '连载中',
    region: '国漫',
    author: '云栖',
    updatedAt: '2026-10-06',
    favorites: 29600,
    popularity: 86,
    rating: 8.9,
    summary: '深宫的一座小亭子里，住着一位不问世事的画师。她替人画像，也替人记录那些说不出口的心事。',
  },
  {
    id: 'comic-012',
    title: '怪兽会社',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20friendly%20office%20staffed%20by%20cute%20friendly%20monsters%20in%20a%20modern%20workplace%2C%20playful%20humor%2C%20bright%20green%20and%20orange%20palette%2C%20vibrant%20cel%20shaded%20style%2C%20simple%20clean%20background%2C%20portrait%20composition&width=600&height=800&seq=comic-cover-012&orientation=portrait',
    tags: ['搞笑', '日常', '职场'],
    genre: '搞笑',
    status: '已完结',
    region: '日本',
    author: '丸子大福',
    updatedAt: '2026-09-30',
    favorites: 35400,
    popularity: 88,
    rating: 9.0,
    summary: '一家专门处理“怪兽事务”的小公司，员工全是妖怪和怪兽。KPI、团建、年度总结……怪兽也要打工啊。',
  },
];